import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';

import './vehicle-image.scss';

function altTextFromVehicle(vehicle) {
  return vehicle ? `${vehicle.year} ${vehicle.makeName} ${vehicle.modelName}` : 'no vehicle photo';
}

export function VehicleImage({
  src = null,
  vehicle = null,
  photoDescText = null,
  isLifestylePhoto,
  imgClasses = null,
  isLazyLoad = false,
}) {
  const altText = photoDescText || altTextFromVehicle(vehicle);

  return (
    <img
      src={src || getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN)}
      alt={altText}
      className={classnames('w-100', imgClasses, { 'default-image': !src })}
      data-lifestyle-photo={isLifestylePhoto}
      {...(isLazyLoad ? { loading: 'lazy' } : {})}
    />
  );
}

VehicleImage.propTypes = {
  src: PropTypes.string,
  vehicle: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    makeName: PropTypes.string,
    modelName: PropTypes.string,
  }),
  photoDescText: PropTypes.string,
  isLifestylePhoto: PropTypes.bool,
  imgClasses: PropTypes.string,
  isLazyLoad: PropTypes.bool,
};
